import { Box, ClickAwayListener, Grid, Typography, useTheme } from "@mui/material";
import { AttributeDisplay as Attribute } from "../model/character";

import styled from 'styled-components';

import { ReactComponent as LeftBunt } from '../images/Heading_EvenBuntLeft.svg';
import { ReactComponent as RightBunt }  from '../images/Heading_EvenBuntRight.svg';
import { useState } from "react";
import Hexagon from "./visual/Hexagon";

const NumberFade = styled.div<{ selected: boolean, xPosition: string }>`
    position: absolute;
    opacity: ${(props) => props.selected ? "1" : "0"};
    left: ${(props) => props.selected ? props.xPosition : "0px"};
    transition: all 0.2s;
`;

export interface AttributeDisplayProps {
    value: Attribute;
    onClick?: () => void;
}

const AttributeDisplay = (props: AttributeDisplayProps) => {
    const {value, onClick} = props;



    return <Grid item xs={4} paddingY={1}>
        <Hexagon name={value.name} content={`${value.withDamage}/${value.current}`} />
    </Grid>;
}

export default AttributeDisplay;